"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestBatch = exports.IkeRestBatchControl = void 0;
var tslib_1 = require("tslib");
var deferred_1 = require("./deferred");
var delayed_task_1 = require("./delayed.task");
var IkeRestBatchControl = /** @class */ (function () {
    function IkeRestBatchControl(boundDepartment) {
        this.boundDepartment = boundDepartment;
        this.batches = {};
    }
    IkeRestBatchControl.prototype.batch = function (obj, key, value) {
        var batchKey = "".concat(obj.actionName, ":").concat(key);
        var batch = this.batches[batchKey];
        if (batch == null || batch.executed) {
            this.batches[batchKey] = batch = new IkeRestBatch(this.boundDepartment.query(obj), key);
        }
        return batch.add(value);
    };
    return IkeRestBatchControl;
}());
exports.IkeRestBatchControl = IkeRestBatchControl;
var IkeRestBatch = /** @class */ (function () {
    function IkeRestBatch(query, key) {
        var _this = this;
        this.runner = new delayed_task_1.IkeDelayedTask(function () { return _this.execute(); }, IkeRestBatch.BATCH_DELAY);
        this.query = query;
        this.key = key;
        this.values = {};
    }
    IkeRestBatch.prototype.add = function (value) {
        var existing = this.values[value];
        if (existing == null) {
            if (this.executed) {
                throw new Error('Cannot add to a executed batch');
            }
            existing = this.values[value] = deferred_1.Deferred.create();
        }
        this.runner.delay();
        return existing.promise;
    };
    IkeRestBatch.prototype.execute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var toFetch, queryBatch, queryBatch_1, queryBatch_1_1, batch, documents, e_1, e_2_1;
            var e_2, _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.executed = true;
                        toFetch = Object.keys(this.values);
                        queryBatch = [];
                        do {
                            queryBatch.push(toFetch.splice(0, IkeRestBatch.BATCH_SIZE));
                        } while (toFetch.length > 0);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, 9, 10]);
                        queryBatch_1 = tslib_1.__values(queryBatch), queryBatch_1_1 = queryBatch_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!queryBatch_1_1.done) return [3 /*break*/, 7];
                        batch = queryBatch_1_1.value;
                        this.query.in(this.key, batch);
                        this.query.limit(batch.length);
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.query.find()];
                    case 4:
                        documents = _b.sent();
                        this.resolveDocuments(batch, documents);
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        batch.map(function (id) { return _this.values[id].reject(e_1); });
                        return [3 /*break*/, 6];
                    case 6:
                        queryBatch_1_1 = queryBatch_1.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_2_1 = _b.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (queryBatch_1_1 && !queryBatch_1_1.done && (_a = queryBatch_1.return)) _a.call(queryBatch_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    IkeRestBatch.prototype.resolveDocuments = function (batch, documents) {
        var e_3, _a, e_4, _b;
        var docMap = {};
        try {
            for (var documents_1 = tslib_1.__values(documents), documents_1_1 = documents_1.next(); !documents_1_1.done; documents_1_1 = documents_1.next()) {
                var document_1 = documents_1_1.value;
                var key = document_1[this.key];
                var deffered = this.values[key];
                docMap[key] = true;
                if (deffered != null) {
                    deffered.resolve(document_1);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (documents_1_1 && !documents_1_1.done && (_a = documents_1.return)) _a.call(documents_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        if (batch.length === documents.length) {
            return;
        }
        try {
            // Resolve null for invalid records
            for (var batch_1 = tslib_1.__values(batch), batch_1_1 = batch_1.next(); !batch_1_1.done; batch_1_1 = batch_1.next()) {
                var key = batch_1_1.value;
                if (docMap[key]) {
                    continue;
                }
                var deffered = this.values[key];
                deffered.resolve(null);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (batch_1_1 && !batch_1_1.done && (_b = batch_1.return)) _b.call(batch_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    IkeRestBatch.BATCH_SIZE = 1000;
    IkeRestBatch.BATCH_DELAY = 5;
    return IkeRestBatch;
}());
exports.IkeRestBatch = IkeRestBatch;
//# sourceMappingURL=batch.js.map